import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { omit } from "lodash";

import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import DeleteAlert from "../../../components/Alert/DeleteAlert";
import ModalAddTask from "./ModalAddTask";

const initial_value = {
  name: "",
  service_type: 1,
  quantity_type: 1,
  quantity: 1,
  //   price: "",
  gst: "",
  hsn: "",
  task: [],
};

const animatedComponents = makeAnimated();

export default function AdminAddService(props: any) {
  const [save_data, SetSaveData] = useState(initial_value);
  const [id_value, SerIdValue] = useState(useParams());
  const [task_list, SetTaskList] = useState([
    {
      name: "",
      price: "",
      skills: [],
    },
  ]);
  const [skill_data, SetSkillData] = useState([]);
  const [page_type, SetPageType] = useState("new");
  const [read_only, SetReadOnly] = useState(false);
  const [service_price_read_only, SetServicePriceReadOnly] = useState(false);
  const [original_data, SetOriginalData] = useState({});
  const [task_modal, SetTaskModal] = useState({
    is_open: false,
    data: [],
  });
  const [deleted_data, SetDeletedData] = useState(false);
  const [errors, setErrors] = useState({});
  const [save_error, SetSaveError] = useState(false);
  const [save_error_task, SetErrorTask] = useState(false);

  const [delete_modal, SetDeleteModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  useEffect(() => {
    console.log("AdminAddService On mount :", id_value);
    if (id_value.service_id != "new") {
      SetPageType("view");
      SetReadOnly(true);
      SetServicePriceReadOnly(true);
      get_service();
    } else {
      SetPageType("new");
      SetSaveData({
        name: "",
        service_type: 1,
        quantity_type: 1,
        quantity: 1,
        // price: "",
        gst: "",
        hsn: "",
        task: [],
      });
      SetReadOnly(false);
      SetServicePriceReadOnly(false);
    }
    get_init();
  }, []);

  async function get_service() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        service_id: id_value.service_id,
      },
    };
    let data = await api("/brand/services_details", pass_data);
    console.log("services_details response :", data.response);
    if (data.response.hasOwnProperty("services")) {
      arrange_value(data.response.services[0]);
    }
  }

  async function get_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
    };
    let data = await api("/brand/create_service_init", pass_data);
    console.log("create_service_init response :", data.response);
    let skill_value = [];
    data.response.skill_categories.map((ele, index) => {
      let value = {};
      value.label = ele.label;
      value.options = ele.skills;
      skill_value.push(value);
    });
    SetSkillData(skill_value);
    // console.log("skill value :", skill_value);
  }

  function validate(name: any, value: any) {
    //A function to validate each input values
    console.log("name :", name);
    console.log("value  :", value);
    switch (name) {
      case "name":
        if (value.length <= 2) {
          // we will set the error state

          setErrors({
            ...errors,
            name: "Service name atleast have 3 letters",
          });
        } else {
          let newObj = omit(errors, "name");
          setErrors(newObj);
        }
        break;

      case "quantity":
        if (value == 0) {
          setErrors({
            ...errors,
            quantity: "Enter a valid number",
          });
        } else {
          let newObj = omit(errors, "quantity");
          setErrors(newObj);
        }
        break;

      case "price":
        if (value == 0) {
          setErrors({
            ...errors,
            price: "Enter valid price",
          });
        } else {
          let newObj = omit(errors, "price");
          setErrors(newObj);
        }
        break;

      case "gst":
        if (value.length == 12) {
          setErrors({
            ...errors,
            gst: "Gst should contains 12 numbers",
          });
        } else {
          let newObj = omit(errors, "gst");
          setErrors(newObj);
        }
        break;

      case "hsn":
        if (value.length <= 0) {
          setErrors({
            ...errors,
            hsn: "Enter hsn not vaild",
          });
        } else {
          let newObj = omit(errors, "hsn");
          setErrors(newObj);
        }
        break;

      default:
        break;
    }
  }

  function set_value(name: any, value: any) {
    validate(name, value);
    SetSaveData((oldValues) => ({ ...oldValues, [name]: value }));
  }

  function add_new_task() {
    console.log("add_new_task");
    let push_data = {
      name: "",
      //   price: "",
      skills: [],
    };
    SetTaskList((prevValue) => {
      prevValue.push(push_data);
      // prevValue.unshift(push_data);
      return [...prevValue];
    });
  }

  function remove_task(index: any) {
    SetTaskList((prevValue) => {
      prevValue.splice(index, 1);
      return [...prevValue];
    });
  }

  function get_selected_skills(value_skills: any) {
    let selected_value = [];
    value_skills.map((ele) => {
      skill_data.map((skill_ele) => {
        let index_value = skill_ele.options.findIndex(
          (op_ele) => op_ele.value == ele
        );
        if (index_value != -1) {
          selected_value.push(skill_ele.options[index_value]);
        }
      });
    });
    return selected_value;
  }

  async function create_service() {
    console.log("save_data :", save_data);

    if (
      save_data.name != "" &&
      save_data.service_type != null &&
      save_data.quantity_type != null
      // save_data.price != null
    ) {
      if (task_list.length > 0) {
        console.log("task_list.length > 0");

        if (task_list[0].name != "" && task_list[0].skills.length > 0) {
          save_data.task = task_list;
          let pass_data = {
            get: {
              brand: id_value.brand_id,
            },
            post: save_data,
          };
          console.log("create_service pass_data :", pass_data);
          let data = await api("/brand/create_service", pass_data);
          console.log("create_service response :", data.response);
          if (data.response.hasOwnProperty("services")) {
            window.history.back();
          }
        } else {
          console.log("Add Atleast One Task Data ");
          SetErrorTask(true);
        }
      } else {
        console.log("no task :", task_list.length);
        SetErrorTask(true);
      }
    } else {
      SetSaveError(true);
    }
  }

  function arrange_value(service_value: any) {
    // let service_value = data.response.services[0];
    console.log("service_value : ", service_value);
    SetOriginalData(service_value);
    SetSaveData((prevValue) => {
      prevValue.name = service_value.name;
      prevValue.service_type = service_value.service_type;
      prevValue.quantity_type = service_value.quantity_type;
      prevValue.quantity = service_value.quantity;
      prevValue.price = service_value.price;
      prevValue.gst = service_value.gst;
      prevValue.hsn = service_value.hsn;
      console.log("save data prevValue : ", prevValue);
      return { ...prevValue };
    });
    let task_value = [];
    service_value.task.map((ele, index) => {
      let value = {
        id: ele.id,
        name: ele.name,
        price: ele.price,
        skills: [],
        price_read_only: true,
        skills_read_only: true,
      };
      ele.skills.map((skill_ele) => {
        value.skills.push(skill_ele.skill_id);
      });
      task_value.push(value);
    });
    SetTaskList(task_value);
    if (service_value.deleted == true) {
      SetDeletedData(true);
    } else {
      SetDeletedData(false);
    }
  }

  async function update_skill(index: any) {
    console.log("update_skill index :", index);
    let task_data = task_list[index];
    if (task_data.skills !== undefined && task_data.skills.length > 0) {
      let pass_data = {
        get: {
          brand: id_value.brand_id,
        },
        post: {
          service_id: id_value.service_id,
          task_id: task_data.id,
          skills: task_data.skills,
        },
      };
      console.log("update_skill pass_data :", pass_data);
      let data = await api("/brand/update_service_task_skills", pass_data);
      console.log("update_service_task_skills response :", data.response);
      if (data.response.hasOwnProperty("services")) {
        arrange_value(data.response.services[0]);
      }
    }
  }

  async function update_task_price(index: any) {
    console.log("update_task_price index :", index);
    let task_data = task_list[index];
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
      post: {
        service_id: id_value.service_id,
        task_id: task_data.id,
        price: task_data.price,
      },
    };
    console.log("update_task_price pass_data :", pass_data);
    let data = await api("/brand/update_service_task_price", pass_data);
    console.log("update_service_task_price response :", data.response);
    if (data.response.hasOwnProperty("services")) {
      arrange_value(data.response.services[0]);
    }
  }

  async function update_service_price() {
    console.log("update_service_price");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
      post: {
        service_id: id_value.service_id,
        price: save_data.price,
      },
    };
    console.log("update_service_price pass_data :", pass_data);
    let data = await api("/brand/update_service_price", pass_data);
    console.log("update_service_price response :", data.response);
    if (data.response.hasOwnProperty("services")) {
      SetServicePriceReadOnly(true);
      arrange_value(data.response.services[0]);
    }
  }

  async function delete_task(index: any) {
    console.log("delete_task : index :", index);
    let task_data = task_list[index];
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
      post: {
        service_id: id_value.service_id,
        task_id: task_data.id,
      },
    };
    console.log("update_task_price pass_data :", pass_data);
    let data = await api("/brand/delete_service_task", pass_data);
    console.log("delete_service_task response :", data.response);
    if (data.status_code === 200) {
      // arrange_value(data.response.services[0]);
      SetTaskList((prevValue) => {
        prevValue.splice(index, 1);
        return [...prevValue];
      });
    }
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4 ">
        <div className="row align-items-center">
          <div className="d-flex">
            <Link
              to={
                "/brand/" +
                id_value.brand_id +
                // "/" +
                // id_value.outlet_id +
                "/service"
              }
              onClick={() => {
                console.log("Set empty:");
              }}
            >
              <img
                src={require("../../../assets/icon/svg/arrow-left.svg")}
                className="action-img pe-2"
              />
            </Link>
            <div>
              <h5 className="  mb-0 text-dark fw-bolder">
                {deleted_data == true
                  ? "Deleted Service"
                  : page_type == "new"
                  ? "Add Service"
                  : "View Service"}
              </h5>
              {deleted_data == false ? (
                page_type == "new" ? (
                  <p className="mb-0">
                    <small>Please fill a correct details</small>
                  </p>
                ) : (
                  <p className="mb-0">
                    <small>View & Edit Service</small>
                  </p>
                )
              ) : (
                <p className="mb-0">
                  <small>Deleted details</small>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container tabs-after-container mb-3">
        <div>
          <div className="mt-3">
            <div className="card p-3">
              <form className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">Service Name</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    readOnly={read_only}
                    value={save_data.name}
                    onChange={(e) => {
                      set_value("name", e.target.value);
                      SetSaveError(false);
                    }}
                  />
                  {errors.name && (
                    <small className="text-red">{errors.name}</small>
                  )}
                  {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                </div>

                <div className="col-md-4">
                  <label className="form-label">Service Method</label>
                  <div className="pt-1">
                    <div className="form-check form-check-inline mb-2">
                      <label className="cursor d-flex align-items-center ">
                        <input
                          // className="form-check-input"
                          type="radio"
                          name="serviceMethodOptions"
                          value="Images"
                          checked={save_data.service_type == 1 ? true : false}
                          disabled={read_only}
                          required
                          onChange={() => {}}
                          onClick={() => {
                            if (!read_only) {
                              set_value("service_type", 1);
                            }
                          }}
                        />
                        <p className="form-check-label ps-2 mb-0">Images</p>
                      </label>
                    </div>
                    <div className="form-check form-check-inline mb-2">
                      <label className="cursor d-flex align-items-center">
                        <input
                          // className="form-check-input"
                          type="radio"
                          name="serviceMethodOptions"
                          value="Videos"
                          checked={save_data.service_type == 2 ? true : false}
                          disabled={read_only}
                          required
                          onChange={() => {}}
                          onClick={() => {
                            if (!read_only) {
                              set_value("service_type", 2);
                            }
                          }}
                        />
                        <p className="form-check-label ps-2 mb-0">Videos</p>
                      </label>
                    </div>
                    <div className="form-check form-check-inline mb-2">
                      <label className="cursor d-flex align-items-center">
                        <input
                          // className="form-check-input"
                          type="radio"
                          name="serviceMethodOptions"
                          value="Audios"
                          checked={save_data.service_type == 3 ? true : false}
                          disabled={read_only}
                          required
                          onChange={() => {}}
                          onClick={() => {
                            if (!read_only) {
                              set_value("service_type", 3);
                            }
                          }}
                        />
                        <p className="form-check-label ps-2 mb-0">Audios</p>
                      </label>
                    </div>
                  </div>
                  {errors.service_type && (
                    <small className="text-red">{errors.service_type}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">Service Type</label>
                  <div className="pt-1">
                    <div className="form-check form-check-inline mb-2">
                      <label className="cursor d-flex align-items-center">
                        <input
                          // className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          value="Item Wise"
                          checked={save_data.quantity_type == 1 ? true : false}
                          disabled={read_only}
                          required
                          onChange={() => {}}
                          onClick={() => {
                            if (!read_only) {
                              set_value("quantity_type", 1);
                            }
                          }}
                        />
                        <p className="form-check-label ps-2 mb-0">Item Wise</p>
                      </label>
                    </div>
                    <div className="form-check form-check-inline mb-2">
                      <label className="cursor d-flex align-items-center">
                        <input
                          // className="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          value="Duration Wise"
                          checked={save_data.quantity_type == 2 ? true : false}
                          disabled={read_only}
                          required
                          onChange={() => {}}
                          onClick={() => {
                            if (!read_only) {
                              set_value("quantity_type", 2);
                            }
                          }}
                        />
                        <p className="form-check-label ps-2 mb-0">
                          Duration Wise
                        </p>
                      </label>
                    </div>
                  </div>
                  {errors.quantity_type && (
                    <small className="text-red">{errors.quantity_type}</small>
                  )}
                </div>

                <div className="col-md-4 col-6">
                  {save_data.quantity_type == 1 ? (
                    <label className="form-label">
                      Quantity for pricing In Image Count
                    </label>
                  ) : (
                    <label className="form-label">
                      Quantity for pricing In Minutes
                    </label>
                  )}

                  <input
                    type="number"
                    className="form-control"
                    value={save_data.quantity}
                    required
                    readOnly={read_only}
                    onChange={(e) => {
                      set_value("quantity", e.target.value);
                      SetSaveError(false);
                    }}
                  />
                  {errors.quantity && (
                    <small className="text-red">{errors.quantity}</small>
                  )}
                  {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                </div>

                {/* <div className="col-md-6">
                  <label className="form-label d-flex">
                    <div>
                      Price for {save_data.quantity}
                      {save_data.quantity_type == 1 ? " Item" : " Min"}
                    </div>
                    <div className="ms-auto">
                      {deleted_data == false ? (
                        page_type != "new" ? (
                          service_price_read_only ? (
                            <div
                              className="mx-2 cursor"
                              onClick={(e) => {
                                e.preventDefault();
                                SetServicePriceReadOnly(false);
                              }}
                            >
                              <img
                                src={require("../../../assets/icon/svg/edit3-1.svg")}
                                className="action-img"
                              />
                              <span className="v-small ms-1 text-dark">
                                Edit
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div
                                className="mx-2 cursor"
                                onClick={(e) => {
                                  e.preventDefault();
                                  update_service_price();
                                }}
                              >
                                <img
                                  src={require("../../../assets/icon/svg/check-1.svg")}
                                  className="action-img"
                                />
                                <span className="v-small ms-1">Done</span>
                              </div>
                              <div
                                className="mx-2 cursor"
                                onClick={(e) => {
                                  e.preventDefault();
                                  SetServicePriceReadOnly(true);
                                  SetSaveData((prevValue) => {
                                    prevValue.price = original_data.price;
                                    return { ...prevValue };
                                  });
                                }}
                              >
                                <img
                                  src={require("../../../assets/icon/svg/x1.svg")}
                                  className="action-img"
                                />
                                <span className="v-small ms-1 text-dark">
                                  Cancel
                                </span>
                              </div>
                            </div>
                          )
                        ) : null
                      ) : null}
                    </div>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">₹</span>
                    <input
                      type="number"
                      className="form-control"
                      value={save_data.price}
                      required
                      readOnly={
                        page_type == "new" ? read_only : service_price_read_only
                      }
                      onChange={(e) => {
                        set_value("price", e.target.value);
                        SetSaveError(false);
                      }}
                    />
                  </div>
                  {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                  {errors.price && (
                    <small className="text-red">{errors.price}</small>
                  )}
                </div> */}

                {/* GST % */}
                {/* <div className="col-md-4 col-6">
                  <label className="form-label">GST %</label>
                  <input
                    type="number"
                    className="form-control"
                    value={save_data.gst}
                    required
                    readOnly={read_only}
                    onChange={(e) => {
                      set_value("gst", e.target.value);
                      SetSaveError(false);
                    }}
                  />
                  {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                  {errors.gst && (
                    <small className="text-red">{errors.gst}</small>
                  )}
                </div> */}

                {/* HSN */}
                {/* <div className=" col-md-4 col-6">
                  <label className="form-label">HSN Code</label>
                  <input
                    type="number"
                    className="form-control"
                    value={save_data.hsn}
                    required
                    readOnly={read_only}
                    onChange={(e) => {
                      set_value("hsn", e.target.value);
                    }}
                  />
                  {errors.hsn && (
                    <small className="text-red">{errors.hsn}</small>
                  )}
                </div> */}
              </form>
            </div>

            <div className="card p-3 mt-3">
              <div className="d-flex mt-3 mb-4 align-items-center">
                <h6>Task</h6>
                {save_error_task == true ? (
                  <small className="text-red">
                    * Atleast One Task Required
                  </small>
                ) : null}
              </div>
              {task_list.map((ele, index) => (
                <div key={index} className="mb-4">
                  <fieldset className="border mt-2">
                    {deleted_data == false ? (
                      <legend className="">
                        <span
                          className="cursor ms-auto text-red bg-white px-3"
                          onClick={() => {
                            if (page_type == "new") {
                              remove_task(index);
                            } else {
                              SetDeleteModal((prevValue) => {
                                prevValue.is_open = true;
                                prevValue.title = "Task";
                                prevValue.record = ele;
                                prevValue.index = index;
                                return { ...prevValue };
                              });
                              // delete_task(index);
                            }
                          }}
                        >
                          <img
                            src={require("../../../assets/icon/svg/x2.svg")}
                            className="action_img pe-2"
                          />
                          Remove
                        </span>
                      </legend>
                    ) : null}
                    <div
                      className={
                        deleted_data == true ? "row p-3 " : "row px-3 pb-3"
                      }
                    >
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Task Name</label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          readOnly={read_only}
                          value={ele.name}
                          onChange={(e) => {
                            SetTaskList((prevValue) => {
                              prevValue[index].name = e.target.value;
                              return [...prevValue];
                            });
                          }}
                        />
                        {save_error_task == true ? (
                          <small className="text-red">
                            * Task Name Required
                          </small>
                        ) : null}
                      </div>

                      {/* <div className="col-md-6 mb-2">
                        <label className="form-label d-flex">
                          <div>Task Price</div>

                          <div className="ms-auto">
                            {deleted_data == false ? (
                              page_type == "view" ? (
                                ele.price_read_only ? (
                                  <div
                                    className="mx-2 cursor"
                                    onClick={() => {
                                      SetTaskList((prevValue) => {
                                        prevValue[index].price_read_only =
                                          false;
                                        return [...prevValue];
                                      });
                                    }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                                      className="action-img"
                                    />
                                    <span className="v-small ms-1 text-dark">
                                      Edit
                                    </span>
                                  </div>
                                ) : (
                                  <div className="d-flex">
                                    <div
                                      className="mx-2 cursor"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        update_task_price(index);
                                      }}
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/check-1.svg")}
                                        className="action-img"
                                      />
                                      <span className="v-small ms-1">Done</span>
                                    </div>
                                    <div
                                      className="mx-2 cursor"
                                      onClick={() => {
                                        SetTaskList((prevValue) => {
                                          prevValue[index].price_read_only =
                                            true;
                                          prevValue[index].price =
                                            original_data.task[index].price;
                                          return [...prevValue];
                                        });
                                      }}
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/x1.svg")}
                                        className="action-img"
                                      />
                                      <span className="v-small ms-1">
                                        Cancel
                                      </span>
                                    </div>
                                  </div>
                                )
                              ) : null
                            ) : null}
                          </div>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          readOnly={ele.price_read_only}
                          value={ele.price}
                          onChange={(e) => {
                            SetTaskList((prevValue) => {
                              prevValue[index].price = e.target.value;
                              return [...prevValue];
                            });
                          }}
                        />
                      </div> */}

                      <div className="col-md-6 mb-2">
                        <label className="form-label d-flex">
                          <div>Skills</div>
                          <div className="ms-auto">
                            {deleted_data == false ? (
                              page_type == "view" ? (
                                ele.skills_read_only ? (
                                  <div
                                    className="mx-2 cursor"
                                    onClick={() => {
                                      SetTaskList((prevValue) => {
                                        prevValue[index].skills_read_only =
                                          false;
                                        return [...prevValue];
                                      });
                                    }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                                      className="action-img"
                                    />
                                    <small className="ms-1 text-dark">
                                      Edit Skills
                                    </small>
                                  </div>
                                ) : (
                                  <div className="d-flex">
                                    <div
                                      className="mx-2 cursor"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        update_skill(index);
                                      }}
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/check-1.svg")}
                                        className="action-img"
                                      />
                                      <span className="v-small ms-1">Done</span>
                                    </div>
                                    <div
                                      className="mx-2 cursor"
                                      onClick={() => {
                                        SetTaskList((prevValue) => {
                                          prevValue[index].skills_read_only =
                                            true;
                                          let skill_value = [];
                                          original_data.task[index].skills.map(
                                            (ele) => {
                                              skill_value.push(ele.skill_id);
                                            }
                                          );
                                          console.log(
                                            "skill_value :",
                                            skill_value
                                          );
                                          prevValue[index].skills = skill_value;
                                          return [...prevValue];
                                        });
                                      }}
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/x1.svg")}
                                        className="action-img"
                                      />
                                      <span className="v-small ms-1">
                                        Cancel
                                      </span>
                                    </div>
                                  </div>
                                )
                              ) : null
                            ) : null}
                          </div>
                        </label>
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isMulti
                          value={get_selected_skills(ele.skills)}
                          options={skill_data}
                          isDisabled={ele.skills_read_only}
                          onChange={(e) => {
                            console.log("on select :", e);
                            SetTaskList((prevValue) => {
                              let s_value = [];
                              e.map((ele) => {
                                s_value.push(ele.value);
                              });
                              prevValue[index].skills = s_value;
                              return [...prevValue];
                            });
                          }}
                        />
                        {save_error_task == true ? (
                          <small className="text-red">* Skills Required</small>
                        ) : null}
                      </div>
                    </div>
                  </fieldset>
                </div>
              ))}
              <div className="ms-auto">
                {deleted_data == false ? (
                  <button
                    className="btn btn-light-outline btn-sm"
                    onClick={() => {
                      if (page_type == "new") {
                        add_new_task();
                      } else {
                        SetTaskModal((prevValue) => {
                          prevValue.is_open = true;
                          prevValue.data = skill_data;
                          return { ...prevValue };
                        });
                      }
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/plus1.svg")}
                      className="action_img pe-1"
                    />
                    Add More Task
                  </button>
                ) : null}
              </div>
            </div>
            {page_type == "new" ? (
              <div className="w-100 text-end mt-3">
                <button
                  className="btn btn-light-outline"
                  onClick={() => {
                    // SetSaveData((prevValue) => {
                    //   prevValue.task = task_list;
                    //   return { ...prevValue };
                    // });
                    create_service();
                  }}
                >
                  Create
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <DeleteAlert
        open={delete_modal.is_open}
        title={delete_modal.title}
        record={delete_modal.record}
        index={delete_modal.index}
        close={(data) => {
          SetDeleteModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete Service : ", data);
            // delete_service(data.value, data.index);
            delete_task(data.index);
          }
        }}
      />

      <ModalAddTask
        open={task_modal.is_open}
        skill_data={task_modal.data}
        close={(data) => {
          console.log("ModalAddTask on close data :", data);
          SetTaskModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          if (data.action == "save") {
            arrange_value(data.services);
          }
        }}
      />
    </div>
  );
}
